import angular from 'angular';
import StreamCompanyLogoDirective from './stream-company-logo.directive';

let StreamCompanyLogoModule = angular.module('stream-company-logo-module', [])

    .directive('streamCompanyLogo', StreamCompanyLogoDirective)

    .name;

export default StreamCompanyLogoModule;


// WEBPACK FOOTER //
// ./client/app/common/stream-company-logo/index.js